import React from 'react'

import FormInput, { FormInputProps } from '../../FormInput'

const Input = <T extends {}>(props: FormInputProps<T>) => {
	return <FormInput autoFocus {...props} />
}

export default Input
